import { CIRCLES_API } from "../../config";
import * as ActionCreators from "./creators";
import { pushNotification } from "../ui_notifications/creators";
import fetchRetry from "../fetch_retry";

export function fetchMemberRequests(id, status) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.fetchingMemberRequests());
    let url = `${CIRCLES_API}/member-request/circle/${id}/${status}`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
    };
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorFetchingMemberRequests(error));
          dispatch(pushNotification("errors.member_requests.fetch", "error"));
        }
      )
      .then((response) => {
        if ("message" in response && response.message === "Internal Server Error") {
          dispatch(pushNotification("errors.member_requests.fetch", "error"));
          dispatch(ActionCreators.errorFetchingMemberRequests(response.message));
        } else {
          if (response.length) {
            dispatch(ActionCreators.fetchedMemberRequests(response, id));
          }
        }
      });
  };
}

export function updateMemberRequest(accept, circleId, requestId) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.updatingRequestStatus(requestId));
    let url = accept ? `${CIRCLES_API}/member-request/accept` : `${CIRCLES_API}/member-request/reject`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify({ request_guid: requestId }),
    };

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorUpdatingMemberRequests(error));
          dispatch(pushNotification("errors.member_requests.update", "error"));
        }
      )
      .then((response) => {
        if ("message" in response && response.message === "Internal Server Error") {
          dispatch(pushNotification("errors.member_requests.update", "error"));
          dispatch(ActionCreators.errorUpdatingMemberRequests(response.message));
        } else {
          dispatch(pushNotification("success.member_requests.update", "success"));
          dispatch(ActionCreators.removeRequest(circleId, requestId));
        }
      });
  };
}

export function joinRequest(circleId) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.joinRequest());
    let url = `${CIRCLES_API}/member-request`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify({ circle_guid: circleId }),
    };

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorJoinRequest(error));
          dispatch(pushNotification("errors.member_requests.join_request", "error"));
        }
      )
      .then((response) => {
        if ("message" in response) {
          if (response.message === "You are a member") {
            dispatch(pushNotification("errors.member_requests.already_member", "error"));
          } else if (response.message === "Duplicated item not allowed") {
            dispatch(pushNotification("errors.member_requests.already_send_join_request", "error"));
          }

          dispatch(ActionCreators.errorJoinRequest(response.message));
        } else {
          dispatch(pushNotification("success.member_requests.join_request", "success"));
          dispatch(ActionCreators.sendMemberRequest([response], circleId));
        }
      });
  };
}
